import { c as _c } from "react/compiler-runtime";
import { Building2, CreditCard, FileText, Lock, QrCode, Receipt, RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { PaymentBadges } from "@/components/layout/payment-badges";
import { LEGAL_DOCS, OPERATOR } from "@/lib/operator";

// Страница «Оплата» — требование банка-эквайера к сайту: способы оплаты,
// принимаемые карты, порядок оплаты картой и 3-D Secure, безопасность, чеки и
// кто принимает деньги. Условия — из Пользовательского соглашения OSMIX
// (разд. 8) и Правил возврата (разд. 8), ничего сверх них не обещаем.
export function PaymentPage() {
  const $ = _c(146);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] !== t) {
    t0 = t("paymentPage.card.title", {
      defaultValue: "\u0411\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0430\u044F \u043A\u0430\u0440\u0442\u0430"
    });
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("paymentPage.card.desc", {
      defaultValue: "\u041A\u0430\u0440\u0442\u044B \u043F\u043B\u0430\u0442\u0451\u0436\u043D\u044B\u0445 \u0441\u0438\u0441\u0442\u0435\u043C \xAB\u041C\u0438\u0440\xBB, Visa \u0438 Mastercard. \u041E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u043E\u0445\u043E\u0434\u0438\u0442 \u043D\u0430 \u0437\u0430\u0449\u0438\u0449\u0451\u043D\u043D\u043E\u0439 \u043F\u043B\u0430\u0442\u0451\u0436\u043D\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0431\u0430\u043D\u043A\u0430."
    });
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      key: "card",
      icon: CreditCard,
      title: t0,
      desc: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("paymentPage.sbp.title", {
      defaultValue: "\u0421\u0438\u0441\u0442\u0435\u043C\u0430 \u0431\u044B\u0441\u0442\u0440\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439"
    });
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("paymentPage.sbp.desc", {
      defaultValue: "\u041E\u043F\u043B\u0430\u0442\u0430 \u043F\u043E QR-\u043A\u043E\u0434\u0443 \u0438\u043B\u0438 \u0441\u0441\u044B\u043B\u043A\u0435 \u0432 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0438 \u0432\u0430\u0448\u0435\u0433\u043E \u0431\u0430\u043D\u043A\u0430, \u0431\u0435\u0437 \u0432\u0432\u043E\u0434\u0430 \u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u0430\u0440\u0442\u044B."
    });
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = {
      key: "sbp",
      icon: QrCode,
      title: t3,
      desc: t4
    };
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("paymentPage.invoice.title", {
      defaultValue: "\u041F\u043E \u0441\u0447\u0451\u0442\u0443 \u0434\u043B\u044F \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0439"
    });
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("paymentPage.invoice.desc", {
      defaultValue: "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u043B\u0438\u0446\u0430 \u0438 \u0418\u041F \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u044E\u0442 \u0437\u0430\u043A\u0430\u0437 \u0431\u0435\u0437\u043D\u0430\u043B\u0438\u0447\u043D\u044B\u043C \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u043E\u043C \u043F\u043E \u0441\u0447\u0451\u0442\u0443, \u0441\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u043C\u0443 \u043F\u043E \u0418\u041D\u041D."
    });
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = {
      key: "invoice",
      icon: Building2,
      title: t6,
      desc: t7
    };
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t2 || $[22] !== t5 || $[23] !== t8) {
    t9 = [t2, t5, t8];
    $[21] = t2;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const methods = t9 as const;
  let t10;
  if ($[25] !== t) {
    t10 = t("paymentPage.steps.1", {
      defaultValue: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u043F\u043B\u0430\u0442\u0443 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u043E\u0439 \u043A\u0430\u0440\u0442\u043E\u0439 \u043F\u0440\u0438 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0438 \u0437\u0430\u043A\u0430\u0437\u0430 \u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \xAB\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C\xBB."
    });
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t) {
    t11 = t("paymentPage.steps.2", {
      defaultValue: "\u041E\u0442\u043A\u0440\u043E\u0435\u0442\u0441\u044F \u043F\u043B\u0430\u0442\u0451\u0436\u043D\u0430\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0431\u0430\u043D\u043A\u0430. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B, \u0441\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0438 \u0442\u0440\u0451\u0445\u0437\u043D\u0430\u0447\u043D\u044B\u0439 \u043A\u043E\u0434 CVC2/CVV2 \u0441 \u043E\u0431\u0440\u0430\u0442\u043D\u043E\u0439 \u0441\u0442\u043E\u0440\u043E\u043D\u044B \u043A\u0430\u0440\u0442\u044B."
    });
    $[27] = t;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t) {
    t12 = t("paymentPage.steps.3", {
      defaultValue: "\u0415\u0441\u043B\u0438 \u043A\u0430\u0440\u0442\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0430 \u043A 3-D Secure, \u0431\u0430\u043D\u043A, \u0432\u044B\u043F\u0443\u0441\u0442\u0438\u0432\u0448\u0438\u0439 \u043A\u0430\u0440\u0442\u0443, \u043F\u043E\u043F\u0440\u043E\u0441\u0438\u0442 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u043F\u043B\u0430\u0442\u0451\u0436, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u043A\u043E\u0434\u043E\u043C \u0438\u0437 SMS."
    });
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t) {
    t13 = t("paymentPage.steps.4", {
      defaultValue: "\u041F\u043E\u0441\u043B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B \u0437\u0430\u043A\u0430\u0437 \u0443\u0445\u043E\u0434\u0438\u0442 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0443, \u0430 \u043A\u0430\u0441\u0441\u043E\u0432\u044B\u0439 \u0447\u0435\u043A \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442 \u043D\u0430 \u0432\u0430\u0448\u0443 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443\u044E \u043F\u043E\u0447\u0442\u0443."
    });
    $[31] = t;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t12 || $[36] !== t13) {
    t14 = [t10, t11, t12, t13];
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  const cardSteps = t14;
  let t15;
  if ($[38] !== t) {
    t15 = t("catalog.breadcrumbHome", {
      defaultValue: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F"
    });
    $[38] = t;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t15) {
    t16 = <Link to="/" className="hover:text-osmix-tangelo">{t15}</Link>;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== t) {
    t17 = t("paymentPage.title", {
      defaultValue: "\u041E\u043F\u043B\u0430\u0442\u0430"
    });
    $[42] = t;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== t17) {
    t18 = <span className="text-[#1F1F1F]">{t17}</span>;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t16 || $[47] !== t18) {
    t19 = <nav aria-label={"\u0425\u043B\u0435\u0431\u043D\u044B\u0435 \u043A\u0440\u043E\u0448\u043A\u0438"} className="flex flex-wrap items-center gap-3 text-[14px] leading-[18px] text-black/50">{t16}{t18}</nav>;
    $[46] = t16;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t) {
    t20 = t("paymentPage.title", {
      defaultValue: "\u041E\u043F\u043B\u0430\u0442\u0430"
    });
    $[49] = t;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== t20) {
    t21 = <h1 className="type-h1-bold">{t20}</h1>;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== t) {
    t22 = t("paymentPage.intro", {
      defaultValue: "\u0417\u0430\u043A\u0430\u0437 \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043E\u043D\u043B\u0430\u0439\u043D \u043F\u0440\u0438 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0438. \u0426\u0435\u043D\u044B \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u0432 \u0440\u0443\u0431\u043B\u044F\u0445 \u0438 \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442 \u043D\u0430\u043B\u043E\u0433\u0438, \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438 \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0434\u043E \u043E\u043F\u043B\u0430\u0442\u044B. \u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043A\u043E\u043C\u0438\u0441\u0441\u0438\u0439 \u0441 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F \u043D\u0435\u0442."
    });
    $[53] = t;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== t22) {
    t23 = <p className="max-w-2xl type-body1 text-osmix-text-2">{t22}</p>;
    $[55] = t22;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== t21 || $[58] !== t23) {
    t24 = <div className="flex flex-col gap-2">{t21}{t23}</div>;
    $[57] = t21;
    $[58] = t23;
    $[59] = t24;
  } else {
    t24 = $[59];
  }
  let t25;
  if ($[60] !== t19 || $[61] !== t24) {
    t25 = <div className="flex flex-col gap-6">{t19}{t24}</div>;
    $[60] = t19;
    $[61] = t24;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[63] !== methods) {
    t26 = <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{methods.map(_temp)}</div>;
    $[63] = methods;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] !== t) {
    t27 = t("paymentPage.accepted", {
      defaultValue: "\u041F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u043C \u043A \u043E\u043F\u043B\u0430\u0442\u0435:"
    });
    $[65] = t;
    $[66] = t27;
  } else {
    t27 = $[66];
  }
  let t28;
  if ($[67] !== t27) {
    t28 = <span className="type-body2 text-osmix-text-2">{t27}</span>;
    $[67] = t27;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  let t29;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <PaymentBadges />;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  let t30;
  if ($[70] !== t28) {
    t30 = <div className="flex flex-col gap-3">{t28}{t29}</div>;
    $[70] = t28;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  let t31;
  if ($[72] !== t) {
    t31 = t("paymentPage.stepsTitle", {
      defaultValue: "\u041A\u0430\u043A \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u043A\u0430\u0440\u0442\u043E\u0439"
    });
    $[72] = t;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  let t32;
  if ($[74] !== t31) {
    t32 = <h2 className="type-h2">{t31}</h2>;
    $[74] = t31;
    $[75] = t32;
  } else {
    t32 = $[75];
  }
  let t33;
  if ($[76] !== cardSteps) {
    t33 = <ol className="flex max-w-3xl flex-col gap-3">{cardSteps.map(_temp2)}</ol>;
    $[76] = cardSteps;
    $[77] = t33;
  } else {
    t33 = $[77];
  }
  let t34;
  if ($[78] !== t32 || $[79] !== t33) {
    t34 = <section className="flex flex-col gap-4">{t32}{t33}</section>;
    $[78] = t32;
    $[79] = t33;
    $[80] = t34;
  } else {
    t34 = $[80];
  }
  let t35;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <Lock className="size-6 shrink-0 text-osmix-tangelo" strokeWidth={1.5} />;
    $[81] = t35;
  } else {
    t35 = $[81];
  }
  let t36;
  if ($[82] !== t) {
    t36 = t("paymentPage.security.title", {
      defaultValue: "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439"
    });
    $[82] = t;
    $[83] = t36;
  } else {
    t36 = $[83];
  }
  let t37;
  if ($[84] !== t36) {
    t37 = <h3 className="type-body1-bold text-osmix-text-1">{t36}</h3>;
    $[84] = t36;
    $[85] = t37;
  } else {
    t37 = $[85];
  }
  let t38;
  if ($[86] !== t) {
    t38 = t("paymentPage.security.desc", {
      defaultValue: "\u041F\u043B\u0430\u0442\u0435\u0436\u0438 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0447\u0435\u0440\u0435\u0437 \u0437\u0430\u0449\u0438\u0449\u0451\u043D\u043D\u044B\u0439 \u0448\u043B\u044E\u0437 \u0431\u0430\u043D\u043A\u0430-\u044D\u043A\u0432\u0430\u0439\u0435\u0440\u0430, \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u043F\u043E \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u0443 PCI DSS. \u0414\u0430\u043D\u043D\u044B\u0435 \u043A\u0430\u0440\u0442\u044B \u043F\u0435\u0440\u0435\u0434\u0430\u044E\u0442\u0441\u044F \u0432 \u0437\u0430\u0448\u0438\u0444\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u043C \u0432\u0438\u0434\u0435 \u043F\u043E \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u0443 TLS \u0438 \u043D\u0435 \u0445\u0440\u0430\u043D\u044F\u0442\u0441\u044F \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 OSMIX."
    });
    $[86] = t;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  let t39;
  if ($[88] !== t38) {
    t39 = <p className="type-body2 text-osmix-text-2">{t38}</p>;
    $[88] = t38;
    $[89] = t39;
  } else {
    t39 = $[89];
  }
  let t40;
  if ($[90] !== t37 || $[91] !== t39) {
    t40 = <article className="flex gap-3 rounded-[16px] border border-osmix-gray-300 p-5">{t35}<div className="flex flex-col gap-1">{t37}{t39}</div></article>;
    $[90] = t37;
    $[91] = t39;
    $[92] = t40;
  } else {
    t40 = $[92];
  }
  let t41;
  if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <Receipt className="size-6 shrink-0 text-osmix-tangelo" strokeWidth={1.5} />;
    $[93] = t41;
  } else {
    t41 = $[93];
  }
  let t42;
  if ($[94] !== t) {
    t42 = t("paymentPage.receipt.title", {
      defaultValue: "\u041A\u0442\u043E \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u043E\u043F\u043B\u0430\u0442\u0443"
    });
    $[94] = t;
    $[95] = t42;
  } else {
    t42 = $[95];
  }
  let t43;
  if ($[96] !== t42) {
    t43 = <h3 className="type-body1-bold text-osmix-text-1">{t42}</h3>;
    $[96] = t42;
    $[97] = t43;
  } else {
    t43 = $[97];
  }
  let t44;
  if ($[98] !== t) {
    t44 = t("paymentPage.receipt.desc", {
      defaultValue: "\u041E\u043F\u043B\u0430\u0442\u0443 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0438 {{entity}} (\u0418\u041D\u041D {{inn}}) \u043A\u0430\u043A \u0430\u0433\u0435\u043D\u0442 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0430. \u041A\u0430\u0441\u0441\u043E\u0432\u044B\u0439 \u0447\u0435\u043A \u043F\u043E 54-\u0424\u0417 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043D\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443\u044E \u043F\u043E\u0447\u0442\u0443 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F.",
      entity: OPERATOR.entity,
      inn: OPERATOR.inn
    });
    $[98] = t;
    $[99] = t44;
  } else {
    t44 = $[99];
  }
  let t45;
  if ($[100] !== t44) {
    t45 = <p className="type-body2 text-osmix-text-2">{t44}</p>;
    $[100] = t44;
    $[101] = t45;
  } else {
    t45 = $[101];
  }
  let t46;
  if ($[102] !== t43 || $[103] !== t45) {
    t46 = <article className="flex gap-3 rounded-[16px] border border-osmix-gray-300 p-5">{t41}<div className="flex flex-col gap-1">{t43}{t45}</div></article>;
    $[102] = t43;
    $[103] = t45;
    $[104] = t46;
  } else {
    t46 = $[104];
  }
  let t47;
  if ($[105] !== t40 || $[106] !== t46) {
    t47 = <div className="grid gap-4 sm:grid-cols-2">{t40}{t46}</div>;
    $[105] = t40;
    $[106] = t46;
    $[107] = t47;
  } else {
    t47 = $[107];
  }
  let t48;
  if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <RotateCcw className="size-6 shrink-0 text-osmix-tangelo" strokeWidth={1.5} />;
    $[108] = t48;
  } else {
    t48 = $[108];
  }
  let t49;
  if ($[109] !== t) {
    t49 = t("paymentPage.refund.title", {
      defaultValue: "\u0412\u043E\u0437\u0432\u0440\u0430\u0442 \u0434\u0435\u043D\u0435\u0433"
    });
    $[109] = t;
    $[110] = t49;
  } else {
    t49 = $[110];
  }
  let t50;
  if ($[111] !== t49) {
    t50 = <h2 className="type-body1-bold text-osmix-text-1">{t49}</h2>;
    $[111] = t49;
    $[112] = t50;
  } else {
    t50 = $[112];
  }
  let t51;
  if ($[113] !== t) {
    t51 = t("paymentPage.refund.desc", {
      defaultValue: "\u0414\u0435\u043D\u044C\u0433\u0438 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u044E\u0442\u0441\u044F \u0442\u0435\u043C \u0436\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C, \u043A\u043E\u0442\u043E\u0440\u044B\u043C \u0431\u044B\u043B \u043E\u043F\u043B\u0430\u0447\u0435\u043D \u0437\u0430\u043A\u0430\u0437: \u043D\u0430 \u0442\u0443 \u0436\u0435 \u043A\u0430\u0440\u0442\u0443 \u0438\u043B\u0438 \u043D\u0430 \u0441\u0447\u0451\u0442, \u0441 \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u043F\u0440\u043E\u0448\u0451\u043B \u043F\u043B\u0430\u0442\u0451\u0436 \u043F\u043E \u0421\u0411\u041F, \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 10 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u044B\u0445 \u0434\u043D\u0435\u0439 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430. \u0421\u0440\u043E\u043A \u0437\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0431\u0430\u043D\u043A\u0430 \u0438 \u043C\u043E\u0436\u0435\u0442 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u0434\u043E 30 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u044B\u0445 \u0434\u043D\u0435\u0439."
    });
    $[113] = t;
    $[114] = t51;
  } else {
    t51 = $[114];
  }
  let t52;
  if ($[115] !== t) {
    t52 = t("paymentPage.refund.link", {
      defaultValue: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0435"
    });
    $[115] = t;
    $[116] = t52;
  } else {
    t52 = $[116];
  }
  let t53;
  if ($[117] !== t52) {
    t53 = <Link to="/returns" className="text-osmix-tangelo hover:underline">{t52}</Link>;
    $[117] = t52;
    $[118] = t53;
  } else {
    t53 = $[118];
  }
  let t54;
  if ($[119] !== t51 || $[120] !== t53) {
    t54 = <p className="type-body2 text-osmix-text-2">{t51}{" "}{t53}</p>;
    $[119] = t51;
    $[120] = t53;
    $[121] = t54;
  } else {
    t54 = $[121];
  }
  let t55;
  if ($[122] !== t50 || $[123] !== t54) {
    t55 = <section className="flex gap-3 rounded-[16px] bg-osmix-tangelo/5 p-5">{t48}<div className="flex flex-col gap-1">{t50}{t54}</div></section>;
    $[122] = t50;
    $[123] = t54;
    $[124] = t55;
  } else {
    t55 = $[124];
  }
  let t56;
  if ($[125] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <FileText className="size-5" />;
    $[125] = t56;
  } else {
    t56 = $[125];
  }
  let t57;
  if ($[126] !== t) {
    t57 = t("paymentPage.offerPdf", {
      defaultValue: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0435 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 (\u043E\u0444\u0435\u0440\u0442\u0430)"
    });
    $[126] = t;
    $[127] = t57;
  } else {
    t57 = $[127];
  }
  let t58;
  if ($[128] !== t57) {
    t58 = <a href={LEGAL_DOCS.offer} target="_blank" rel="noreferrer" className="flex w-fit items-center gap-2 rounded-[12px] bg-osmix-text-1 px-5 py-3 type-button text-white outline-none transition-colors hover:bg-osmix-text-1/90 focus-visible:ring-2 focus-visible:ring-osmix-tangelo/40">{t56}{t57}</a>;
    $[128] = t57;
    $[129] = t58;
  } else {
    t58 = $[129];
  }
  let t59;
  if ($[130] === Symbol.for("react.memo_cache_sentinel")) {
    t59 = <FileText className="size-5" />;
    $[130] = t59;
  } else {
    t59 = $[130];
  }
  let t60;
  if ($[131] !== t) {
    t60 = t("paymentPage.legalEntityPdf", {
      defaultValue: "\u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u043E\u043F\u043B\u0430\u0442\u044B \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C\u0438 \u043B\u0438\u0446\u0430\u043C\u0438"
    });
    $[131] = t;
    $[132] = t60;
  } else {
    t60 = $[132];
  }
  let t61;
  if ($[133] !== t60) {
    t61 = <a href={LEGAL_DOCS.legalEntityPayment} target="_blank" rel="noreferrer" className="flex w-fit items-center gap-2 rounded-[12px] border border-osmix-gray-300 px-5 py-3 type-button text-osmix-text-1 outline-none transition-colors hover:bg-[#F8F8F8] focus-visible:ring-2 focus-visible:ring-osmix-tangelo/40">{t59}{t60}</a>;
    $[133] = t60;
    $[134] = t61;
  } else {
    t61 = $[134];
  }
  let t62;
  if ($[135] !== t58 || $[136] !== t61) {
    t62 = <div className="flex flex-wrap gap-3">{t58}{t61}</div>;
    $[135] = t58;
    $[136] = t61;
    $[137] = t62;
  } else {
    t62 = $[137];
  }
  let t63;
  if ($[138] !== t25 || $[139] !== t26 || $[140] !== t30 || $[141] !== t34 || $[142] !== t47 || $[143] !== t55 || $[144] !== t62) {
    t63 = <div className="flex flex-col gap-8">{t25}{t26}{t30}{t34}{t47}{t55}{t62}</div>;
    $[138] = t25;
    $[139] = t26;
    $[140] = t30;
    $[141] = t34;
    $[142] = t47;
    $[143] = t55;
    $[144] = t62;
    $[145] = t63;
  } else {
    t63 = $[145];
  }
  return t63;
}
function _temp2(step, i) {
  return <li key={step} className="flex gap-3 type-body1 text-osmix-text-1"><span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-osmix-tangelo/10 type-body2 font-semibold text-osmix-tangelo">{i + 1}</span><span className="pt-0.5">{step}</span></li>;
}
function _temp(m) {
  return <section key={m.key} className="flex flex-col gap-3 rounded-[16px] bg-[#F8F8F8] p-5"><span className="flex size-11 items-center justify-center rounded-[12px] bg-white text-osmix-tangelo"><m.icon className="size-6" strokeWidth={1.5} /></span><h2 className="type-h5 text-osmix-text-1">{m.title}</h2><p className="type-body2 text-osmix-text-2">{m.desc}</p></section>;
}